/**
 * 健康状态枚举
 */

export const healthStatusE = {
    Unknown: {
        value: 0,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_UNKNOWN',
    },
    Normal: {
        value: 1,
        i18n: 'common.EnumDefine_STATUS_E_NORMAL',
    },
    Fault: {
        value: 2,
        i18n: 'common.EnumDefine_HEALTH_STATUS_fault',
    },
    Pre_Fail: {
        value: 3,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_PRE_FAIL',
    },
    PART_BROKEN: {
        value: 4,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_PART_BROKEN',
    },
    Degraded: {
        value: 5,
        i18n: 'common.EnumDefine_HEALTH_STATUS_degraded',
    },
    HAS_BAD_BLOCK: {
        value: 6,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_HAS_BAD_BLOCK',
    },
    HAS_ERR_CODE: {
        value: 7,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_HAS_ERR_CODE',
    },
    CONSISTENT: {
        value: 8,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_CONSISTENT',
    },
    INCONSISTENT: {
        value: 9,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_INCONSISTENT',
    },
    BUSY: {
        value: 10,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_BUSY',
    },
    POWER_NO_INPUT: {
        value: 11,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_POWER_NO_INPUT',
    },
    POWER_NOT_ENOUGH: {
        value: 12,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_POWER_NOT_ENOUGH',
    },
    SINGLE_LINK_FAULT: {
        value: 13,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_SINGLE_LINK_FAULT',
    },
    Invalid: {
        value: 14,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_INVALID',
    },
    WriteProtect: {
        value: 15,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_WRITE_PROTECT',
    },
    SingleLink: {
        value: 16,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_SINGLE_LINK',
    },
    NoRedundantLink: {
        value: 17,
        i18n: 'common.EnumDefine_HEALTH_STATUS_E_NO_REDUNDANT_LINK',
    },
    OFFLINE: {
        value: 18,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_OFFLINE',
    },
};

// 健康状态图标
export const healthStatusSvg = {
    1: 'normal',
    2: 'faulty',
    14: 'invalid',
    15: 'write-protected',
};
